import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  Slide,
} from "@mui/material";
import React, { useState, forwardRef } from "react";
import StarRateIcon from "@mui/icons-material/StarRate";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import { useCart } from "../../context/CartContext";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const CartModel = ({
  testOne,
  title,
  short_description,
  rating,
  minimum_order_quantity,
  is_restro_open,
  currency,
  item,
  type,
}) => {
  const [open, setOpen] = useState(false);
  const [quantity, setQuantity] = useState(1);
  const { store_data, remove_data } = useCart();  // Assuming remove_data and store_data are from CartContext

  // Open dialog
  const handleClickOpen = () => {
    let cart = localStorage.getItem("cart");
    cart = cart ? JSON.parse(cart) : [];
    let is_item_present = false;

    if (cart.length > 0) {
      for (let i = 0; i < cart.length; i++) {
        if (cart[i].id === item.id) {
          setQuantity(cart[i].qty);
          is_item_present = true;
          break;
        }
      }
    }

    if (!is_item_present) {
      setQuantity(minimum_order_quantity);
    }
    setOpen(true);
  };

  // Close dialog
  const handleClose = () => {
    setOpen(false);
  };

  // Decrement quantity
  const handleDecrement = () => {
    if (quantity > minimum_order_quantity) {
      setQuantity(prevCount => prevCount - 1);
    }
  };

  // Increment quantity
  const handleIncrement = () => {
    setQuantity(prevCount => prevCount + 1);
  };

  const storeData = (data, quantity) => {
    store_data(data.id, quantity, data.name, data.sell_price, data.photo, 1, 2, true, data.vendor_id);
    handleClose();
    testOne();
  };

  const itemPrice = item.sell_price;
  const totalCost = itemPrice * quantity;

  return (
    <>
      {type !== 0 && type != null ? (
        <Button variant="text" color="primary" onClick={handleClickOpen}>
          <ArrowRightIcon />
          Edit
        </Button>
      ) : (
        <Button variant="outlined" color="error" onClick={handleClickOpen}>
          + Add To Cart
        </Button>
      )}

      {/* Cart dialog */}
      {is_restro_open ? (
        <Dialog
          open={open}
          TransitionComponent={Transition}
          keepMounted
          onClose={handleClose}
          maxWidth={"md"}
        >
          <DialogTitle>
            <span className="highlight pop_title">{title}</span>
            <p className="short_description">{short_description}</p>
            <div className="price_content">
              <Typography variant="body1" component="h5" sx={{ fontWeight: "500", color: "green" }}>
                {currency}{item.sell_price.toFixed(2)}
              </Typography>
              {rating > 0.0 && (
                <div className="rated">
                  {rating}
                  <StarRateIcon className="staricon" />
                </div>
              )}
            </div>
          </DialogTitle>
          <DialogContent className="border">
            <div className="quantity_sec">
              <div className="quatity_title">
                <p>Quantity </p>
              </div>
              <div className="add_minus_quantity">
                <span className="minus_icon">
                  <RemoveIcon
                    className={quantity > minimum_order_quantity ? "minus_quantity2" : "minus_quantity"}
                    onClick={handleDecrement}
                  />
                </span>
                <input type="text" value={quantity} readOnly />
                <span className="plus_icon">
                  <AddIcon className="plus_quantity" onClick={handleIncrement} />
                </span>
              </div>
            </div>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              Cancel
            </Button>
            <Button
              onClick={() => storeData(item, quantity)}
              color="primary"
            >
              {item.qty > 0 ? "Edit Cart" : "Add to Cart"}
            </Button>
          </DialogActions>
        </Dialog>
      ) : null}
    </>
  );
};

export default CartModel;
